module.exports = __webpack_public_path__ + "static/yelp-logo-grey-347458a20b3f452a680ed9fda2a574e6.svg";